import { Container, Paper, Typography, useMediaQuery } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import LoadingComponent from "../../../Common/LoadingComponent";
import PageAndToolStrip from "../../../Common/PageAndToolStrip";
import theme from "../../../themes/theme";
import { useVStore } from "../../stores/vStore";
import ProjectFreeForm from "./ProjectFreeForm";

import { UserRights } from "../../models/progmaUserRights";
import {
  getProjectAndSubjectDisplayLine,
  Status,
} from "../../models/projectAndSubject";
import ProjectForm from "../Projects/ProjectForm";
import CProjectsAndSubjectsSDTOSelect from "../../../Common/controls/CProjectsAndSubjectsSDTOSelect";
import CCheckbox from "../../../Common/controls/CCheckBox";
import ProjectFreeTable from "./ProjectFreeTable";

export default observer(function ProjectFree() {
  const {
    projectFreeStore: {
      loadProjectsAndSubjects,
      projectsAndSubjects,
      isLoading,
      isLoadingProjectFree,
      loadProjectsFree,
      projectAndSubjectId,
      addProjectFree,
      editProjectFree,
      addProject,
      setProjectStatus,
      isLoadingProjectStatus,
      allProjectsAndSubjects,
      setAllProjectsAndSubjects,
      isLoadingProjectsAndSubjects
    },
    projectFreeFormStore: {
      projectFreeForm,
      openProjectFreeForm,
      closeProjectFreeForm,
    },
    progmaUserStore: { progmaUserRights },
    projectFormStore: { projectForm, openProjectForm, closeProjectForm },
  } = useVStore();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (!projectsAndSubjects) loadProjectsAndSubjects();
  }, [projectsAndSubjects, loadProjectsAndSubjects]);

  const mySelectControl = (
    <div style={{ width: !matches ? 448 : 288 }}>
      <CProjectsAndSubjectsSDTOSelect
        name='projectsAndSubjectsID'
        label='Kies project'
        value={projectAndSubjectId}
        required
        useSearchField
        onChange={(id) => typeof id === "number" && loadProjectsFree(id)}
        items={projectsAndSubjects?.map((x) => ({
          id: x.id,
          text: getProjectAndSubjectDisplayLine(x),
          sourceObject: x,
        }))}
        allProjectsAndSubjects={allProjectsAndSubjects}
        onAllProjectsAndSubjectsChanged={setAllProjectsAndSubjects}
        isLoadingProjectsAndSubjects={isLoadingProjectsAndSubjects}
        onAddButtonClick={
          progmaUserRights?.projectsUserRights === UserRights.Editing
            ? () => openProjectForm()
            : undefined
        }
      ></CProjectsAndSubjectsSDTOSelect>
    </div>
  );

  const projectAndSubjectChoosed =
    projectAndSubjectId !== undefined
      ? projectsAndSubjects?.filter((x) => x.id === projectAndSubjectId)[0]
      : undefined;

  const pageContent = isLoadingProjectFree ? (
    <LoadingComponent useBackdrop={false} />
  ) : (
    projectAndSubjectChoosed !== undefined && (
      <div style={{ marginTop: theme.spacing(1), minWidth: 288 }}>
        <Paper
          style={{ marginBottom: theme.spacing(2), padding: theme.spacing(2) }}
        >
          <Typography>Project status:</Typography>
          {isLoadingProjectStatus ? (
            <LoadingComponent useBackdrop={false} />
          ) : (
            <>
              <CCheckbox
                label='Opdracht'
                name='statusOrder'
                required={false}
                checked={
                  projectAndSubjectChoosed.status === Status.Opdracht ||
                  projectAndSubjectChoosed.status ===
                    Status.Opdrachtbevestiging_gestuurd
                }
                onChange={(checked) =>
                  checked &&
                  setProjectStatus(projectAndSubjectChoosed.id, Status.Opdracht)
                }
              />
              <CCheckbox
                label='Gereed'
                name='statusOrder'
                required={false}
                checked={projectAndSubjectChoosed.status === Status.Gereed}
                onChange={(checked) =>
                  checked &&
                  setProjectStatus(projectAndSubjectChoosed.id, Status.Gereed)
                }
              />
            </>
          )}
        </Paper>

        <Paper>
          <ProjectFreeTable/>
        </Paper>
      </div>
    )
  );

  if (isLoading) return <LoadingComponent useBackdrop={false} />;

  return (
    <Container maxWidth={"xl"} style={{ padding: 0 }}>
      <PageAndToolStrip
        onAddButtonClick={progmaUserRights?.projectFreeUserRights === UserRights.Editing &&
          projectAndSubjectId
            ? () => openProjectFreeForm(projectAndSubjectId)
            : undefined
        }
        secondaryToolStripTools={mySelectControl}
      >
        {pageContent}
      </PageAndToolStrip>

      {projectFreeForm.open && (
        <ProjectFreeForm
          open={projectFreeForm.open}
          id={projectFreeForm.id}
          //projectsAndSubjectsId={projectAndSubjectId}
          onCreated={addProjectFree}
          onEdited={editProjectFree}
          onClose={closeProjectFreeForm}
        />
      )}

      {progmaUserRights?.projectsUserRights === UserRights.Editing &&
        projectForm.open && (
          <ProjectForm
            open={projectForm.open}
            id={projectForm.id}
            onCreated={(project) =>
              addProject(project).then((newId) => {
                if (newId !== undefined) loadProjectsFree(newId);
              })
            }
            onEdited={() => {}}
            onClose={closeProjectForm}
          />
        )}
    </Container>
  );
});
